import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "mb-15" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_11 = {
  key: 0,
  class: "col-12"
}
const _hoisted_12 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_14 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" CONTACTS "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('feature.auth.$invitation.email_address')), 1 /* TEXT */),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('feature.auth.$invitation.instructions')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" CREATE "),
            _createCommentVNode(" EMAIL "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                  required: "",
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                  placeholder: _ctx.$t('form.email.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                  [_vModelText, _ctx.email]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.email ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({
                  path: '/'
                })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.invite_user')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.error_message), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "successModal",
      title: _ctx.$t('feature.auth.invitation'),
      dismissible: false,
      message: _ctx.$t('feature.auth.$invitation.send_success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"])
  ], 64 /* STABLE_FRAGMENT */))
}